import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { XdrSearchWebComponentSchema } from '../types';

export class XdrSearchBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<XdrSearchWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
